import { render, staticRenderFns } from "./AnexoEmailCartao.vue?vue&type=template&id=ec05e2e4&scoped=true"
import script from "./AnexoEmailCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./AnexoEmailCartao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec05e2e4",
  null
  
)

export default component.exports